import { TestFormPGSEC } from '../../features/pgSecTests'
import { RouteProps } from '../../routes/AppRouter'
import { Title } from '../../components/common/Title'
import { TITLE_PATIENTS_PGSEC } from '../../routes/title-constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

export const Form = (props: RouteProps) => {
  const { t } = useTranslation()
  const [isResultsView, setIsResultsView] = React.useState(false as boolean)

  return (
    <>
      {isResultsView ? (
        <div style={{ position: 'sticky', top: 64, zIndex: 60, background: 'white', paddingTop: 30, marginLeft: -16, marginRight: -16 }}>
          <Title title={t(TITLE_PATIENTS_PGSEC)} color={props.color} />
        </div>
      ) : (
        <Title title={t(TITLE_PATIENTS_PGSEC)} color={props.color} />
      )}
      <TestFormPGSEC onResultsModeChange={setIsResultsView} />
    </>
  )
}
